import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Button,
  Grid,
  Paper,
  Box,
  IconButton,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { CourseData } from '../types/types';
import pyqData from '../data/pyq_links.json';

const ExamPage: React.FC = () => {
  const { courseCode } = useParams<{ courseCode: string }>();
  const navigate = useNavigate();
  const [selectedExam, setSelectedExam] = useState<string | null>(null);
  const data: CourseData = pyqData;

  if (!courseCode || !data[courseCode]) {
    return (
      <Container>
        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Typography variant="h5" color="error">
            Course not found
          </Typography>
          <Button
            startIcon={<ArrowBack />}
            onClick={() => navigate('/')}
            sx={{ mt: 2 }}
          >
            Go Back
          </Button>
        </Box>
      </Container>
    );
  }

  const examTypes = Object.keys(data[courseCode]);

  const handleExamClick = (examType: string) => {
    setSelectedExam(examType === selectedExam ? null : examType);
  };

  const handleYearClick = (year: string, link: string) => {
    window.open(link, '_blank');
  };

  return (
    <Container>
      <Box sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
          <IconButton onClick={() => navigate('/')} sx={{ mr: 2 }}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h4">
            {courseCode} - Previous Year Questions
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {examTypes.map((examType) => (
            <Grid item xs={12} sm={6} md={4} key={examType}>
              <Paper
                elevation={3}
                sx={{
                  p: 2,
                  cursor: 'pointer',
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                  },
                }}
              >
                <Button
                  fullWidth
                  variant={selectedExam === examType ? 'contained' : 'outlined'}
                  onClick={() => handleExamClick(examType)}
                  sx={{ mb: selectedExam === examType ? 2 : 0 }}
                >
                  {examType}
                </Button>

                {selectedExam === examType && (
                  <Box sx={{ mt: 2 }}>
                    <Grid container spacing={1}>
                      {Object.entries(data[courseCode][examType]).map(
                        ([year, link]) => (
                          <Grid item xs={6} key={year}>
                            <Button
                              fullWidth
                              variant="outlined"
                              size="small"
                              onClick={() => handleYearClick(year, link)}
                            >
                              {year}
                            </Button>
                          </Grid>
                        )
                      )}
                    </Grid>
                  </Box>
                )}
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default ExamPage; 